import { useCallback } from "react";
import { useBaseSummary } from "hooks/useBaseSummary";

export const usePalletsSummary = ({ orderId }) => {
	const buildFilter = useCallback(() => {
		if (!orderId) return null;
		return { order_id: orderId };
	}, [orderId]);

	const { summaryTotals, loading, refetch } = useBaseSummary({
		endpoint: "/pallets-summary",
		buildFilter,
	});

	return {
		summaryTotals,
		loading,
		fetchSummaryTotals: refetch,
	};
};
